import {Injectable} from '@angular/core';
import {InsolesTypeFamilySummaryModel} from './insolesTypeFamilySummary.model';
import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';

@Injectable()
export class InsolesTypeFamilySummaryConverter extends HttpModelConverter<InsolesTypeFamilySummaryModel> {

    constructor() {
        super();
    }

    protected createInstance(): InsolesTypeFamilySummaryModel {
        return new InsolesTypeFamilySummaryModel();
    }

    protected enrichObject(result: InsolesTypeFamilySummaryModel, src: InsolesTypeFamilySummaryModel) {
    }

}
